import clsx from "clsx";
import { sortBy } from "lodash";
import React, { useMemo } from "react";
import { Experience, GiftOffer, UnitType } from "types";
import { DemographicItem } from "./CreatePurchaseDemographicPicker";
import { useProduct } from "@/hooks/resources/useProduct";
import { getCatalogItemsByUnitType } from "@/models/Catalog";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const CreatePurchaseGiftDemographicPicker = () => {
    const giftOffer = useCreatePurchaseStore((state) => state.getActiveProduct<GiftOffer>());
    const totalQuantity = useCreatePurchaseStore((state) => state.getActiveItem().quantity);

    const { data: experience } = useProduct<Experience>(giftOffer?.experience?.id);

    const experienceCatalogItems = experience?.catalog?.items ? experience.catalog.items : [];

    const demographicCatalogItems = getCatalogItemsByUnitType(experienceCatalogItems, UnitType.DEMOGRAPHIC);
    const sortedDemographicCatalogItems = useMemo(
        () => sortBy(demographicCatalogItems, "sequence"),
        [demographicCatalogItems],
    );

    if (!experience) {
        return null;
    }

    let { orderMax = Number.MAX_VALUE, outingMax = Number.MAX_VALUE } = experience?.group ?? {};
    if (orderMax > outingMax) {
        orderMax = outingMax;
    }

    const availabilityMax = Math.max(orderMax, outingMax);

    const error = totalQuantity > availabilityMax ? `Quantity cannot exceed ${availabilityMax}` : undefined;

    return (
        <div className="space-y-2">
            <div className={clsx("text-sm font-bold", { "text-danger": error })}>{error ?? "Quantity"}</div>
            <div className="flex flex-col items-start space-y-2">
                {sortedDemographicCatalogItems.map((demographicCatalogItem) => {
                    return (
                        <DemographicItem
                            key={`${experience.id}${demographicCatalogItem.id}`}
                            demographicCatalogItem={demographicCatalogItem}
                            max={availabilityMax}
                            min={1}
                            experience={experience}
                            error={error}
                        />
                    );
                })}
            </div>
        </div>
    );
};
